import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { StreamInfo, ITopology } from '../../app/apiSlice';
import { StatusChip } from "./StatusChip";
import moment from "moment";
import { useSecureApplication } from "../../hooks/KeycloackConnection";
import ElapsedTime from "../../utils/ElapsedTime";
import { DisplayEnv } from "../../components/environnement/DisplayEnv";
import { CorrespondenceEnv } from "../../utils/correspondenceEnv";

interface IDataTableWorkFlows {
  workflows: StreamInfo[];
  isLoading: boolean;
  refetchStream: () => void;
}

export const DataTableWorkFlows = ({
  workflows,
  isLoading,
}: IDataTableWorkFlows) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const { hasAnyPerm } = useSecureApplication();

  const goToOneWorkflowPage = (stream: StreamInfo) => {
    navigate(`/workflow`, {state: { topologyID: stream.name, flowID: stream.flowId }});
  };

  const emptyMessage = () => {
    return <div>Aucun flux n'a été trouvé</div>;
  };

  return (
    <>
      <DataTable
        value={workflows}
        responsiveLayout="scroll"
        paginator
        rows={5}
        rowsPerPageOptions={[5, 10, 25, 50]}
        loading={isLoading}
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords}"
        paginatorClassName={"justify-content-end"}
        emptyMessage={emptyMessage}
      >
        <Column
          field="name"
          header={t("table.name")}
          sortable
          expander
          body={(i: StreamInfo) => {
            return (
              <div
                className={"link"}
                style={{display: 'flex', flexDirection: 'column', gap: '5px'}}
                onClick={() => {
                  goToOneWorkflowPage(i);
                }}
              >
                <div>
                  <b>{i.label}</b>
                </div>
                <div style={{color: '#B0B0B0'}}><i>{i.flowId}</i></div>
              </div>
            );
          }}
        />

        <Column
          field="environnement"
          header={t("table.environnement")}
          sortable
          expander
          body={(i: StreamInfo) => {
            return (
              <DisplayEnv
                name={CorrespondenceEnv(i.environnement)}
                code={i.environnement}
              />
            );
          }}
        />
        <Column
          header={t("table.creation")}
          sortable
          sortField={"start_time"}
          body={(i: StreamInfo) => {
            return (
              <>
                <div>
                  {i?.start_time
                    ? moment(i.start_time).format("lll")
                    : t("label.invalid-date")}
                </div>
              </>
            );
          }}
        />
        <Column
          header={t("table.duration")}
          body={(i: StreamInfo) => {
            return (
              <ElapsedTime
                startDate={new Date(i?.start_time)}
                endDate={i?.close_time ? new Date(i?.close_time) : null}
              ></ElapsedTime>
            );
          }}
        />
        <Column
          header={"Etat"}
          sortable
          field={"status"}
          body={(i: StreamInfo) => {
            return (
              <div className="statusList">
                {/* Flow status */}
                {<StatusChip status={i.status} />}
              </div>
            );
          }}
        />

        {/*<Column*/}
        {/*  header={t("table.actions")}*/}
        {/*  body={(i: StreamInfo) => {*/}
        {/*    return (*/}
        {/*      <div>*/}
        {/*        <SplitButton*/}
        {/*          label={t("label.details")}*/}
        {/*          icon="pi pi-info-circle"*/}
        {/*          model={[*/}
        {/*            {*/}
        {/*              label: t("button.open"),*/}
        {/*              icon: "pi pi-pencil",*/}
        {/*              disabled: findIdRow(i),*/}
        {/*              command: () => {*/}
        {/*                navigate(`/editor?t=${i.run_id}`);*/}
        {/*              },*/}
        {/*            },*/}
        {/*            {*/}
        {/*              label: t("button.stop"),*/}
        {/*              icon: "pi pi-stop",*/}
        {/*              disabled: !hasAnyPerm("flows.all", "flows_stop"),*/}
        {/*              command: async () => {*/}
        {/*                try {*/}
        {/*                  await stopStream({ name: i.name, env: '' }).unwrap();*/}
        {/*                  dispatch(*/}
        {/*                    setToast({*/}
        {/*                      severity:"success",*/}
        {/*                      life:3000,*/}
        {/*                      content:`FLux ${i.name} arrêté.`,*/}
        {/*                      title:"Arrêt"*/}
        {/*                    })*/}
        {/*                  )*/}
        {/*                  refetchStream()*/}
        {/*                } catch {*/}
        {/*                  dispatch(*/}
        {/*                    setToast({*/}
        {/*                      severity:"error",*/}
        {/*                      life:3000,*/}
        {/*                      content:"Impossible d'arrêter",*/}
        {/*                      title:"Erreur"*/}
        {/*                    })*/}
        {/*                  )*/}
        {/*                }*/}
        {/*                */}
        {/*              },*/}
        {/*            },*/}
        {/*          ]}*/}
        {/*          className="p-button-primary p-button-text ml-2"*/}
        {/*          // onClick={() => {*/}
        {/*          //   goToOneWorkflowPage(i);*/}
        {/*          // }}*/}
        {/*        />*/}
        {/*      </div>*/}
        {/*    );*/}
        {/*  }}*/}
        {/*/>*/}
      </DataTable>
    </>
  );
};
